export const ALL_COMPANIES = 'All companies'
export const TABS = ['All', 'Active', 'Inactive']

// The company dropdown: "All companies", then every company actually present
// in the roster, listed once each.
export function companyOptions(users) {
  const names = new Set()

  for (const user of users) {
    names.add(user.company)
  }

  return [ALL_COMPANIES, ...names]
}

// Each step below hands a new, shorter list to the next one. The full roster is
// never changed — which is why switching a filter is instant and reversible.
export function filterUsers(users, { company, tab, query, offlineFirst }) {
  let list = users

  if (company !== ALL_COMPANIES) {
    list = list.filter((user) => user.company === company)
  }

  if (tab === 'Active') {
    list = list.filter((user) => user.active)
  }

  if (tab === 'Inactive') {
    list = list.filter((user) => !user.active)
  }

  // Lower-cased once here, not once per row.
  const needle = query.trim().toLowerCase()
  if (needle) {
    list = list.filter((user) => matches(user, needle))
  }

  if (offlineFirst) {
    // `.sort` reorders a list in place rather than making a new one. If no
    // filter above ran, `list` is still the caller's own array — sorting it
    // directly would quietly reorder the roster itself. So: copy, then sort.
    list = [...list].sort((a, b) => Number(a.active) - Number(b.active))
  }

  return list
}

function matches(user, needle) {
  return (
    user.user.toLowerCase().includes(needle) ||
    user.code.toLowerCase().includes(needle) ||
    user.company.toLowerCase().includes(needle)
  )
}

// Which slice of the filtered list belongs on the page the user is looking at.
// `page` is clamped, because a filter can shrink the list under the user's feet
// and leave them pointing at a page that no longer exists.
export function pageSlice(list, page, perPage) {
  const total = list.length
  const maxPage = Math.max(0, Math.ceil(total / perPage) - 1)
  const safePage = Math.min(page, maxPage)
  const start = safePage * perPage

  return {
    total,
    safePage,
    start,
    rows: list.slice(start, start + perPage),
  }
}
